function buildMenu (allowed) {
  if (allowed == null || allowed.includes('Finance') || allowed.includes('Taxes'))  {
    return [
    {
      title: 'Finance',
      icon: 'mdi-currency-usd',
      items: [
        {
          icon: 'mdi-file-percent',
          title: 'Inventory',
          path: '/TaxInventory'
        },
        {
          icon: 'mdi-bank',
          title: 'Payments',
          path: '/FinPayments'
        },
        {
          icon: 'mdi-cash-register',
          title: 'Receivables',
          path:'/TaxReceivables'
        },
        // {
        //   icon: 'mdi-cash-multiple',
        //   title: 'tax_ar',
        //   table: 'tax_ar'
        // },
        {
          icon: 'mdi-file-document-outline',
          title: 'Reports',
          path: '/FinReports'
        }
      ]
    }
  ] } else return []
}

export default buildMenu